<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (type === 'Add') {
    <div i18n="@@addNewValueProposal">Add New Value Proposal</div>
  }
  @if (type !== 'Add') {
    <div i18n="@@editValueProposal">Edit Value Proposal</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeIcon" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addProposalForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@salesSenarioLabel">Sales scenario</mat-label>
        <textarea data-testid="sales_senario" matInput id="sales_senario" placeholder="Sales scenario" i18n-placeholder="@@salesSenarioPlaceholder" name="sales_senario" formControlName="sales_senario" required></textarea>
        <mat-error>
          @if (!addProposalForm.get('sales_senario').valid && addProposalForm.get('sales_senario').touched) {
            @if (addProposalForm.get('sales_senario').errors?.required || addProposalForm.get('sales_senario').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@productValueLabel">Product value</mat-label>
        <textarea data-testid="product_value" matInput id="product_value" placeholder="Product value" i18n-placeholder="@@productValuePlaceholder" name="product_value" formControlName="product_value" required></textarea>
        <mat-error>
          @if (!addProposalForm.get('product_value').valid && addProposalForm.get('product_value').touched) {
            @if (addProposalForm.get('product_value').errors?.required || addProposalForm.get('product_value').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-chip-grid #chipList [disabled]="departmentCtrl.disabled">
          @for (department of departments; track department; let index = $index) {
            <mat-chip-row
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(department, index)">
              {{department.name}}
              @if (removable) {
                <mat-icon matChipRemove i18n-label="@@removeChipIcon" aria-label="Remove">cancel</mat-icon>
              }
            </mat-chip-row>
          }
          <input
            data-testid="department_input"
            (keyup)="searchDepartment($event)"
            placeholder="Departments *"
            i18n-placeholder="@@departmentsPlaceholder"
            #departmentInput
            required
            [formControl]="departmentCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-grid>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          @for (department of filteredDepartments | async; track department) {
            <mat-option [value]="department">
              {{department.name}}
            </mat-option>
          }
        </mat-autocomplete>
        @if (isLoading) {
          <mat-icon class="cursor" matSuffix>
            <mat-spinner class="spinner" diameter="20"></mat-spinner>
          </mat-icon>
        }
      </mat-form-field>
      @if (departments.length === 0 && departmentError) {
        <div i18n="@@invalidDepartmentsMessage" class="error">Please enter departments to proceed</div>
      }

      <div i18n="@@supportMaterials" class="mat-subtitle-1 medium-font" matTooltip ellipsisTooltip>Support Materials</div>
      <mat-divider class="mb-24"></mat-divider>

      <div class="d-flex align-items-base">
        @if (!fileIconOn) {
          <mat-form-field class="flex-grow" appearance="outline">
            <mat-label i18n="@@linkLabel">Link</mat-label>
            <input data-testid="add_edit_link" matInput id="link" placeholder="Link" i18n-placeholder="@@linkPlaceholder" name="link" formControlName="link" />
            <mat-error>
              @if (addProposalForm.get('link').errors && addProposalForm.get('link').errors['pattern']) {
                <span i18n="@@inValidLink">Please add correct link!</span>
              }
            </mat-error>
          </mat-form-field>
        }
        @if (fileIconOn) {
          <mat-form-field (click)="imgFileInput.click();" class="flex-grow" appearance="outline">
            <mat-label i18n="@@fileLabel">File</mat-label>
            <input data-testid="add_edit_file" matInput id="file" placeholder="File" i18n-placeholder="@@filePlaceholder" name="file" formControlName="file" />
          </mat-form-field>
        }
        <mat-icon class="{{!fileIconOn ? 'cursor off-icon-color' : 'cursor on-icon-color'}}" (click)="imgFileInput.click();toggleIcon('file')" i18n-label="@@fileIcon" aria-label="File">insert_drive_file</mat-icon>
        <mat-icon class="{{fileIconOn ? 'cursor off-icon-color' : 'cursor on-icon-color'}}" (click)="toggleIcon('link')" i18n-label="@@linkIcon" aria-label="Link">insert_link</mat-icon>
        <mat-icon data-testid="add_file_button" (click)="addFileOrListToList()" class="cursor add-icon add" svgIcon="add" i18n-label="@@addIcon" aria-label="Add"></mat-icon>
        <input accept=".png, .jpg, .jpeg, .txt, .html, .pdf, .rtf, .doc, .docx, .ppt, .pptx, .xls, .xlsx" hidden type="file" onclick="this.value=null" #imgFileInput (change)="previewImage($event.target.files)"/>
      </div>
      <!-- <div i18n="@@invalidFilesMessage" *ngIf="allFiles.length ===  0 && type === 'Add'" class="{{!fileIconOn && !addProposalForm.controls.link.valid ? 'error mt-0' : 'error'}}">Please add files to proceed!</div> -->
      <!-- <div i18n="@@invalidFilesMessage" *ngIf="allFiles.length ===  0 &&  valueProposal?.supportMaterials.length ===  0 && type === 'Edit'" class="{{!fileIconOn && !addProposalForm.controls.link.valid ? 'error mt-0' : 'error'}}">Please add files to proceed!</div> -->
      @for (item of allFiles; track item; let index = $index) {
        <div class="mat-caption d-flex mb-28">
            @if (item.type === utils.supportMaterials.Link) {
              <span class="mr-auto" matTooltip ellipsisTooltip>{{truncate(item.file)}}</span>
            }
            @if (item.type === utils.supportMaterials.File) {
              <span class="mr-auto" matTooltip ellipsisTooltip>{{truncate(item.file.name)}}</span>
            }
           @if (item.type === utils.supportMaterials.File) {
              <mat-icon class="on-icon-color" i18n-label="@@fileIcon" aria-label="File">insert_drive_file</mat-icon>
            }
            @if (item.type === utils.supportMaterials.Link) {
              <mat-icon class="on-icon-color" i18n-label="@@linkIcon" aria-label="Link">insert_link</mat-icon>
            }
          <mat-icon class="cursor mr-35" (click)="deleteFromFileList(index)" color="warn" i18n-label="@@deleteIcon" aria-label="Delete">delete_outline</mat-icon>
        </div>
      }

      @for (item of valueProposal?.supportMaterials; track item; let index = $index) {
        <div class="mat-caption d-flex mb-28">
            @if (item.type === utils.supportMaterials.Link) {
              <span class="mr-auto" matTooltip ellipsisTooltip>{{truncate(item.path)}}</span>
            }
            @if (item.type !== utils.supportMaterials.Link) {
              <span class="mr-auto" matTooltip ellipsisTooltip>{{truncate(item.fileName)}}</span>
            }
            @if (item.type !== utils.supportMaterials.Link) {
              <mat-icon class="on-icon-color" i18n-label="@@fileIcon" aria-label="File">insert_drive_file</mat-icon>
            }
            @if (item.type === utils.supportMaterials.Link) {
              <mat-icon class="on-icon-color" i18n-label="@@linkIcon" aria-label="Link">insert_link</mat-icon>
            }
            <mat-icon class="cursor" (click)="deleteValueProposalMaterial(item.id, index)" color="warn">delete_outline</mat-icon>
          <a href="{{item.path}}" target="_blank">
            <mat-icon color="accent" class="cursor ml-11" i18n-label="@@downloadIcon" aria-label="Download">get_app</mat-icon>
          </a>
        </div>
      }
    </div>

    <div>
      @if (type === 'Add') {
        <button i18n="@@add" data-testid="add_proposal_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
      }
      @if (type !== 'Add') {
        <button i18n="@@save" data-testid="edit_proposal_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Save</button>
      }
    </div>
  </form>
</mat-dialog-content>